/**
 * @generated SignedSource<<2a989a5fab7a00d0dd8cf9e21787bea2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView$data = {
  readonly cascadingOption: {
    readonly childOptionValue: {
      readonly value: string | null | undefined;
    } | null | undefined;
    readonly parentOptionValue: {
      readonly value: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView";
};
export type cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView$key = {
  readonly " $data"?: cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "cascadingSelect_issueFieldCascadingSelectReadviewFull_CascadingSelectReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraCascadingOption",
      "kind": "LinkedField",
      "name": "cascadingOption",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "parentOptionValue",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "childOptionValue",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    }
  ],
  "type": "JiraCascadingSelectField"
};
})();

(node as any).hash = "ff5454b1cc5b1b18150500d392d7759f";

export default node;
